import React from 'react';
import { ActionButton, Title, LoadingShimmer } from '@icarros/ids-react';
import { useHistory } from 'react-router-dom';
import { usePerformanceContext } from '../../../store/contexts/performance';
import { MetricsHeader } from '../style';

export function Header(): JSX.Element {
  const history = useHistory();
  const { currentAd } = usePerformanceContext();
  const { veiculo } = currentAd.data || {};

  return (
    <MetricsHeader>
      <ActionButton
        variant="neutral"
        weight="small"
        text="voltar"
        iconName="itaufonts_seta"
        onClick={() => history.goBack()}
      />

      <Title size="overline">performance do anúncio</Title>
      <LoadingShimmer show={currentAd.isLoading} height="35px" width="350px">
        <Title>
          {veiculo?.marca.nome} {veiculo?.versao.nome}
        </Title>
      </LoadingShimmer>
    </MetricsHeader>
  );
}
